/**
 * Shipping types for demand forecasting
 */
export enum ShippingType {
  Train = 'train',
  Ship = 'ship',
  Truck = 'truck'
}

/**
 * Track how a forecast was updated
 */
export enum ForecastUpdatedVia {
  User = 'user',
  Mail = 'mail'
}
